'use strict';

module.exports = require('./components/DisqusThread');


//////////////////
// WEBPACK FOOTER
// ./~/react-disqus-comments/build/main.js
// module id = 1455
// module chunks = 107818501498521